import { useMemo } from 'react';
import useCrmSearchQuery from 'framework-listing-lib/hooks/useCrmSearchQuery';
import useFetcher from './useFetcher';
import { useCrmObjectType } from '../providers/CrmObjectTypeListingClientProvider';
export default function useCrmObjectTypeFetchParams(args = {
  includeHiddenFilter: true
}) {
  const crmSearchQuery = useCrmSearchQuery(args);
  const fetcher = useFetcher();
  const {
    associationSpecs
  } = useCrmObjectType();
  const value = useMemo(() => {
    const variables = {
      associationSpecs,
      fetcher,
      fetchParams: crmSearchQuery
    };
    return variables;
  }, [associationSpecs, crmSearchQuery, fetcher]);
  return value;
}